import ajax from '@/utils/ajax';
import { getRobotIdFromCookie } from './tools';
const fetchMenuUrl = '/v1/robotConf/robot/filterMenu';
const getLinkUrl = '/v1/robotConf/robot/getIframePage';

export default {
    fetchMenu: data => ajax.gatewayPost(fetchMenuUrl, {
        ...data,
        robotId: getRobotIdFromCookie(),
        // path: window.location.pathname,
    }),
    getLink: () => ajax.gatewayPost(getLinkUrl, {
        robotId: getRobotIdFromCookie(),
        path: window.location.pathname,
    }),
};
